import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Helmet } from "react-helmet";
import BookingModal from "./BookModal";
import NotFound from './NotFound';
const parseListFromHtml = (html) => {
  if (!html) return [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  return Array.from(doc.querySelectorAll("li")).map(li =>
    li.textContent.trim()
  );
};
function ActivityDetails () {

const shareOnWhatsApp = () => {
  const pageUrl = window.location.href;

  const message = `Hi! I found this amazing ${details.title} and thought you might like it.
View details here:
${pageUrl}
Let me know what you think.`;

  const phoneNumber = "971569825050"; // country code included

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");
};

  const { slug } = useParams();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "inr");
  const [highlights, setHighlights] = useState([]);
  const [inclusions, setInclusions] = useState([]);
  const [exclusions, setExclusions] = useState([]);
  const [destination, setDestination] = useState([]);

  useEffect(() => {
    const updateCurrency = () => {
      setCurrency(localStorage.getItem("currency") || "inr");
    };

    window.addEventListener("currency-change", updateCurrency);
    return () => window.removeEventListener("currency-change", updateCurrency);
  }, []);

  const getPrice = (item) => {
    if (!item) return "";

    if (currency === "usd") return `$${item.price_usd}`;
    if (currency === "aed") return `AED ${item.price_aed}`;
    return `₹${item.price_inr}`;
  };

  const [formData, setFormData] = useState({
    full_name: "",
    email_address: "",
    total_persons: "",
    travel_date: "",
    tour_detail: "",
    saveInfo: false,
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

/* ===============================
     BULLET HTML PARSER (FINAL)
  =============================== */
const parseListFromHtml = (htmlString) => {
  if (!htmlString) return [];

  // 1️⃣ Decode unicode escaped HTML
  let decoded;
  try {
    decoded = JSON.parse(`"${htmlString}"`);
  } catch (e) {
    decoded = htmlString;
  }

  // 2️⃣ Parse decoded HTML
  const div = document.createElement("div");
  div.innerHTML = decoded;

  // 3️⃣ Extract <li> items
  return Array.from(div.querySelectorAll("li"))
    .map(li => li.textContent.replace(/\s+/g, " ").trim())
    .filter(Boolean);
};



useEffect(() => {
  if (!slug) return;

  setLoading(true);
  setNotFound(false);

  fetch(`https://planjourneysglobal.com/admin/api/activity/${slug}`)
    .then((res) => res.json())
    .then((data) => {
      console.log("API Response:", data);

      if (
        data?.status === true &&
        data?.data &&
        Object.keys(data.data).length > 0
      ) {
        setDetails(data.data);
      } else {
        setDetails(null);
        setNotFound(true); // add this
      }

      setLoading(false);
    })
    .catch((err) => {
      console.error("Activity API Error:", err);

      setDetails(null);
      setNotFound(true); // add this

      setLoading(false);
    });
}, [slug]);


// useEffect(() => {
//   if (!slug) return;

//   setLoading(true);

//   fetch(`https://planjourneysglobal.com/admin/api/activity/${slug}`)
//     .then((res) => res.json())
//     .then((data) => {
//       if (data.status) {
//         setDetails(data.data);
//       } else {
//         setDetails(null);
//       }
//       setLoading(false);
//     })
//     .catch((err) => {
//       console.error("Activity API Error:", err);
//       setLoading(false);
//     });
// }, [slug]);

  

    useEffect(() => {
    if (!details?.highlights_of_activity) return;
  
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      details.highlights_of_activity,
      "text/html"
    );
  
    const parsedHighlights = Array.from(
      doc.querySelectorAll("li")
    ).map(li => li.textContent.trim());
  
    setHighlights(parsedHighlights);
  }, [details]);
  
  
    useEffect(() => {
    if (!details) return;
  
    setInclusions(parseListFromHtml(details.inclusion));
    setExclusions(parseListFromHtml(details.exclusion));
  }, [details]);

  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetch(
        "https://planjourneysglobal.com/admin/api/booking",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          mode: "cors",

        }
      );

      const result = await response.json();

      if (response.ok) {
        setSuccessMsg("Your enquiry has been submitted successfully!");

        // Reset form
        setFormData({
          full_name: "",
          email_address: "",
          total_persons: "",
          travel_date: "",
          tour_detail: "",
          saveInfo: false,
        });

        setTimeout(() => {
          const modalEl = document.getElementById("enquiryModal");
          const modal = window.bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();
          setSuccessMsg("");
        }, 10000);
      } else {
        setErrorMsg(result.message || "Something went wrong!");
      }
    } catch (error) {
      setErrorMsg("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  if (!details?.location_id || !details?.id) return;

  fetch(
    `https://planjourneysglobal.com/admin/api/relevant_activities/${details.location_id}/${details.id}`
  )
    .then((res) => res.json())
    .then((data) => {
      setDestination(data?.data || []);
    })
    .catch((err) => console.error("Relevant API Error:", err));
}, [details]);


if (loading) return <p></p>;

if (notFound) return <NotFound />;



    return(
<>

  <Helmet>
      {/* <title>{details.meta_title}</title>
      <meta name="description" content={details.meta_description} /> */}

      {details.meta_keyword && <meta name="keywords" content={details.meta_keyword} />}
      {/* {details.slug && <link rel="canonical" href={details.slug} />}
 {details.image && (
          <meta
            property="og:image"
            content={`https://planjourneysglobal.com/admin/${details.image}`}
          />
        )}      
         {details.image && (
      <meta name="twitter:image"
        content={`https://planjourneysglobal.com/admin/${details.image}`}
      />
    )}
      <meta property="og:title" content={details.meta_title} />
      <meta property="og:description" content={details.meta_description} />
      {details.slug && <meta property="og:url" content={details.slug} />}
      <meta property="og:type" content="website" />

      <meta name="twitter:title" content={details.meta_title} />
      <meta name="twitter:description" content={details.meta_description} />
      <meta name="twitter:card" content="summary_large_image" /> */}
    </Helmet>
 <Header/>

  <style>
        {`
        .col-md-6.Childs,
        .col-md-6.Adults {
          display: none;
        }
        `}
      </style>
 <div
  className="breadcrumb-section"
  style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("${details.gallery.replace(/\\/g, '')}")`
  }}
>
  <div className="container">
    <div className="banner-content">
      <h1>{details.title}</h1>
    </div>
  </div>
</div>
  <div className="package-details-breadcrumb-bottom">
    <div className="container">
      <div className="details-breadcrumb-bottom-wrapper">
        <div className="left-content">
          <ul>
            <li>
              <svg
                width={12}
                height={12}
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.544 3.68665L4.87161 10.3626C4.76529 10.4653 4.63053 10.5186 4.49589 10.5186C4.42605 10.5187 4.35687 10.505 4.29236 10.4782C4.22785 10.4514 4.16929 10.4122 4.12005 10.3626L0.457651 6.70021C0.248491 6.49453 0.248491 6.15781 0.457651 5.94865L1.75173 4.65097C1.95033 4.45249 2.30481 4.45249 2.50341 4.65097L4.49589 6.64346L9.49833 1.63741C9.54761 1.58803 9.60613 1.54883 9.67055 1.52206C9.73498 1.49529 9.80405 1.48148 9.87381 1.48141C10.0155 1.48141 10.1503 1.53817 10.2495 1.63741L11.5436 2.93521C11.7531 3.14437 11.7531 3.48109 11.544 3.68665Z" />
              </svg>
              No Booking Fee
            </li>
            <li>
              <svg
                width={12}
                height={12}
                viewBox="0 0 12 12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.544 3.68665L4.87161 10.3626C4.76529 10.4653 4.63053 10.5186 4.49589 10.5186C4.42605 10.5187 4.35687 10.505 4.29236 10.4782C4.22785 10.4514 4.16929 10.4122 4.12005 10.3626L0.457651 6.70021C0.248491 6.49453 0.248491 6.15781 0.457651 5.94865L1.75173 4.65097C1.95033 4.45249 2.30481 4.45249 2.50341 4.65097L4.49589 6.64346L9.49833 1.63741C9.54761 1.58803 9.60613 1.54883 9.67055 1.52206C9.73498 1.49529 9.80405 1.48148 9.87381 1.48141C10.0155 1.48141 10.1503 1.53817 10.2495 1.63741L11.5436 2.93521C11.7531 3.14437 11.7531 3.48109 11.544 3.68665Z" />
              </svg>
              Best Price Ever
            </li>
          </ul>
       
        </div>
        <div className="right-content">
         
         
        </div>
      </div>
    </div>
  </div>
  {/* Breadcrumb section End*/}
  {/* Location Details Modal section Start*/}
  <div
    className="modal location-details-modal fade"
    id="packageLocationModal"
    tabIndex={-1}
    aria-labelledby="packageLocationModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <button
          type="button"
          className="close-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            width={10}
            height={10}
            viewBox="0 0 10 10"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2.00247 0.500545C1.79016 0.505525 1.58918 0.582706 1.4362 0.735547L0.694403 1.479C0.345704 1.82743 0.389689 2.43243 0.79164 2.83493L3.00694 5.05341L0.79164 7.27092C0.389689 7.67328 0.345566 8.27842 0.694403 8.62753L1.4362 9.37044C1.7849 9.71872 2.38879 9.67543 2.7913 9.27293L5.00659 7.05473L7.22189 9.27293C7.62467 9.67543 8.22898 9.71872 8.57699 9.37044L9.31989 8.62753C9.6679 8.27856 9.62461 7.67342 9.22182 7.27092L7.00653 5.05341L9.22182 2.83493C9.62461 2.43243 9.6679 1.82743 9.31989 1.479L8.57699 0.735547C8.22898 0.386433 7.62467 0.430557 7.22189 0.833614L5.00659 3.05126L2.7913 0.833753C2.56515 0.606635 2.27482 0.493906 2.00247 0.500545Z" />
          </svg>
        </button>
        <div className="modal-header">
          <h4 className="modal-title" id="packageLocationModalLabel">
            Eiffel Tower, France : 02 Days
          </h4>
        </div>
        <div className="modal-body">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-activities-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-activities"
                type="button"
                role="tab"
                aria-controls="pills-activities"
                aria-selected="true"
              >
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.99978 15.1112C2.14378 15.1112 0.888672 13.8561 0.888672 8.00006C0.888672 2.14406 2.14378 0.888947 7.99978 0.888947C13.8558 0.888947 15.1109 2.14406 15.1109 8.00006C15.1109 13.8561 13.8558 15.1112 7.99978 15.1112ZM10.0005 4.7515C9.94844 4.65679 9.87145 4.57812 9.77789 4.52402C9.68432 4.46991 9.57773 4.44243 9.46967 4.44455C9.36161 4.44667 9.25618 4.47831 9.16481 4.53604C9.07344 4.59378 8.9996 4.6754 8.95128 4.77209L6.49334 9.68795L5.40795 7.7145C5.35682 7.62152 5.28165 7.54398 5.19032 7.48997C5.09898 7.43597 4.99481 7.40747 4.8887 7.40747H3.85167C3.52439 7.40747 3.25909 7.67278 3.25909 8.00006C3.25909 8.32734 3.52439 8.59264 3.85167 8.59264H4.53834L5.99912 11.2486C6.05121 11.3433 6.1282 11.4219 6.22177 11.476C6.31534 11.5301 6.42192 11.5576 6.52998 11.5555C6.63804 11.5534 6.74346 11.5218 6.83483 11.464C6.9262 11.4063 7.00005 11.3247 7.04837 11.228L9.50631 6.3122L10.5917 8.28564C10.6428 8.37862 10.718 8.45617 10.8093 8.51018C10.9007 8.56418 11.0048 8.59267 11.1109 8.59267H12.148C12.4752 8.59267 12.7405 8.32736 12.7405 8.00009C12.7405 7.67281 12.4752 7.4075 12.148 7.4075H11.4613L10.0005 4.7515Z"
                    />
                  </g>
                </svg>
                Tour Activities
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-accommodation-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-accommodation"
                type="button"
                role="tab"
                aria-controls="pills-accommodation"
                aria-selected="false"
              >
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.82319 1.65145L9.10418 2.3548L9.27418 3.34814C9.30165 3.51015 9.17758 3.65982 9.01118 3.65982C8.92088 3.65982 8.96778 3.67185 7.99883 3.16048L7.11082 3.62915C6.91581 3.73208 6.68654 3.56621 6.72348 3.34814L6.89348 2.3548L6.17447 1.65145C6.0162 1.49678 6.10487 1.22858 6.32247 1.19678L7.31515 1.05211L7.75949 0.148765C7.85716 -0.0494382 8.14036 -0.0497382 8.23817 0.148765L8.6825 1.05211L9.67519 1.19678C9.89319 1.22865 9.98112 1.49712 9.82319 1.65145ZM5.21629 3.01617L5.18479 2.8325C5.30809 2.7123 5.44626 2.61543 5.38569 2.42906C5.32516 2.2428 5.15519 2.24536 4.98602 2.22076L4.90355 2.05366C4.80595 1.85586 4.52298 1.85572 4.42528 2.05366L4.34281 2.22076C4.17241 2.24553 4.00367 2.24266 3.94314 2.42906C3.8826 2.61533 4.02164 2.71317 4.14404 2.8325L4.11254 3.01617C4.07527 3.23354 4.30407 3.39998 4.49948 3.29728L4.66438 3.21054C4.83322 3.29934 4.87005 3.32791 4.95335 3.32791C5.11789 3.32791 5.24435 3.17971 5.21629 3.01617ZM2.88292 4.34953L2.85142 4.16586C2.97472 4.04565 3.11289 3.94879 3.05232 3.76242C2.99179 3.57615 2.82182 3.57871 2.65265 3.55411L2.57018 3.38701C2.47258 3.18921 2.18961 3.18908 2.09191 3.38701L2.00944 3.55411C1.83904 3.57888 1.6703 3.57601 1.60977 3.76242C1.54923 3.94869 1.68827 4.04652 1.81067 4.16586L1.77917 4.34953C1.7419 4.5669 1.97071 4.73333 2.16611 4.63063L2.33101 4.5439C2.49985 4.6327 2.53668 4.66126 2.61998 4.66126C2.78452 4.66126 2.91099 4.51306 2.88292 4.34953ZM11.885 3.01617L11.8535 2.8325C11.9768 2.7123 12.115 2.61543 12.0544 2.42906C11.9939 2.2428 11.8239 2.24536 11.6547 2.22076C11.5785 2.06626 11.5291 1.90502 11.3332 1.90502C11.1373 1.90502 11.0872 2.06746 11.0116 2.22076L10.8272 2.24756C10.6089 2.2793 10.5213 2.54837 10.6794 2.70244L10.8128 2.8325C10.7837 3.00231 10.7288 3.16181 10.8874 3.27698C11.0458 3.39211 11.1818 3.29011 11.3332 3.21054C11.502 3.29934 11.5388 3.32791 11.6221 3.32791C11.7866 3.32791 11.9131 3.17971 11.885 3.01617ZM14.2184 4.34953L14.1869 4.16586C14.3102 4.04565 14.4484 3.94879 14.3878 3.76242C14.3273 3.57615 14.1573 3.57871 13.9881 3.55411C13.9119 3.39961 13.8625 3.23838 13.6665 3.23838C13.4707 3.23838 13.4206 3.40081 13.3449 3.55411L13.1605 3.58091C12.9423 3.61265 12.8547 3.88172 13.0127 4.03579L13.1462 4.16586C13.117 4.33566 13.0622 4.49516 13.2208 4.61033C13.3792 4.72546 13.5152 4.62346 13.6665 4.5439C13.8354 4.6327 13.8722 4.66126 13.9555 4.66126C14.12 4.66126 14.2464 4.51306 14.2184 4.34953ZM4.07074 15.7257C4.0753 15.8759 3.95447 16 3.80417 16H2.39871C1.80961 16 1.33203 15.5224 1.33203 14.9333V9.5999C1.33203 9.01079 1.80961 8.53322 2.39871 8.53322H3.79873C3.946 8.53322 4.0654 8.65289 4.0654 8.80016C4.0651 13.8222 4.0567 15.2656 4.07074 15.7257ZM3.16539 11.1999C3.16539 11.1292 3.1373 11.0614 3.08729 11.0114C3.03727 10.9614 2.96945 10.9333 2.89872 10.9333C2.828 10.9333 2.76017 10.9614 2.71016 11.0114C2.66015 11.0614 2.63205 11.1292 2.63205 11.1999V12.3333C2.63205 12.404 2.66015 12.4718 2.71016 12.5218C2.76017 12.5719 2.828 12.5999 2.89872 12.5999C2.96945 12.5999 3.03727 12.5719 3.08729 12.5218C3.1373 12.4718 3.16539 12.404 3.16539 12.3333V11.1999ZM14.6656 9.5999V14.9333C14.6656 15.5224 14.188 16 13.5989 16H12.1937C12.0434 16 11.9225 15.8759 11.9271 15.7257C11.9412 15.2664 11.9325 13.8251 11.9322 8.80016C11.9322 8.65289 12.0516 8.53322 12.1989 8.53322H13.5989C14.188 8.53322 14.6656 9.01079 14.6656 9.5999ZM13.3655 11.1999C13.3655 11.1292 13.3374 11.0614 13.2874 11.0114C13.2374 10.9614 13.1696 10.9333 13.0989 10.9333C13.0281 10.9333 12.9603 10.9614 12.9103 11.0114C12.8603 11.0614 12.8322 11.1292 12.8322 11.1999V12.3333C12.8322 12.404 12.8603 12.4718 12.9103 12.5218C12.9603 12.5719 13.0281 12.5999 13.0989 12.5999C13.1696 12.5999 13.2374 12.5719 13.2874 12.5218C13.3374 12.4718 13.3655 12.404 13.3655 12.3333V11.1999ZM7.33212 16H8.66547C8.7362 16 8.80403 15.9719 8.85404 15.9219C8.90405 15.8719 8.93214 15.8041 8.93214 15.7333V13.2333C8.93214 13.1626 8.90405 13.0947 8.85404 13.0447C8.80403 12.9947 8.7362 12.9666 8.66547 12.9666H7.33212C7.26139 12.9666 7.19356 12.9947 7.14355 13.0447C7.09354 13.0947 7.06545 13.1626 7.06545 13.2333V15.7333C7.06545 15.8041 7.09354 15.8719 7.14355 15.9219C7.19356 15.9719 7.26139 16 7.33212 16ZM11.3988 5.79985V15.7333C11.3988 15.8041 11.3707 15.8719 11.3207 15.9219C11.2707 15.9719 11.2029 16 11.1322 16H9.73215C9.66143 16 9.5936 15.9719 9.54359 15.9219C9.49358 15.8719 9.46548 15.8041 9.46548 15.7333V12.6999C9.46548 12.6292 9.43739 12.5614 9.38738 12.5114C9.33737 12.4614 9.26954 12.4333 9.19881 12.4333H6.79878C6.72805 12.4333 6.66022 12.4614 6.61021 12.5114C6.5602 12.5614 6.53211 12.6292 6.53211 12.6999V15.7333C6.53211 15.8041 6.50401 15.8719 6.454 15.9219C6.40399 15.9719 6.33616 16 6.26544 16H4.86542C4.79469 16 4.72686 15.9719 4.67685 15.9219C4.62684 15.8719 4.59875 15.8041 4.59875 15.7333V5.79985C4.59875 5.21074 5.07632 4.73316 5.66543 4.73316H10.3322C10.9213 4.73316 11.3988 5.21074 11.3988 5.79985ZM9.33215 10.2666C9.33215 10.1959 9.30405 10.128 9.25404 10.078C9.20403 10.028 9.1362 9.99991 9.06548 9.99991H6.93211C6.86139 9.99991 6.79356 10.028 6.74355 10.078C6.69354 10.128 6.66544 10.1959 6.66544 10.2666C6.66544 10.3373 6.69354 10.4051 6.74355 10.4551C6.79356 10.5052 6.86139 10.5332 6.93211 10.5332H9.06548C9.1362 10.5332 9.20403 10.5052 9.25404 10.4551C9.30405 10.4051 9.33215 10.3373 9.33215 10.2666ZM9.79882 7.69987C9.79882 7.62915 9.77073 7.56132 9.72072 7.51131C9.6707 7.4613 9.60288 7.4332 9.53215 7.4332H6.46544C6.39471 7.4332 6.32689 7.4613 6.27687 7.51131C6.22686 7.56132 6.19877 7.62915 6.19877 7.69987C6.19877 7.7706 6.22686 7.83843 6.27687 7.88844C6.32689 7.93845 6.39471 7.96655 6.46544 7.96655H9.53215C9.60288 7.96655 9.6707 7.93845 9.72072 7.88844C9.77073 7.83843 9.79882 7.7706 9.79882 7.69987Z" />
                </svg>
                Accommodation
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-transport-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-transport"
                type="button"
                role="tab"
                aria-controls="pills-transport"
                aria-selected="false"
              >
                <svg
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path d="M9.05095 0.435C8.47095 -0.145 7.53095 -0.145 6.95095 0.435L0.436953 6.95C-0.143047 7.53 -0.143047 8.469 0.436953 9.048L6.95295 15.564C7.53295 16.144 8.47195 16.144 9.05095 15.564L15.567 9.048C16.147 8.468 16.147 7.529 15.567 6.95L9.05095 0.435ZM10.494 5.197L11.508 6.303L8.75095 8.83V12H7.25095V8.83L4.49395 6.303L5.50795 5.197L8.00095 7.483L10.494 5.197Z" />
                  </g>
                </svg>
                Transport
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-activities"
              role="tabpanel"
              aria-labelledby="pills-activities-tab"
            >
              <div className="single-activity mb-60">
                <span className="title">Day-01</span>
                <div className="row g-4">
                  <div className="col-md-4 col-sm-6">
                    <div className="activity-card">
                      <div className="activity-img">
                        <img
                          src="/assets/img/innerpages/location-modal-activity-img1.jpg"
                          alt=""
                        />
                      </div>
                      <div className="activity-content">
                        <h6>Climb the Eiffel Tower</h6>
                        <p>
                          The Eiffel Tower, one of the most iconic landmarks in
                          the world, offers an incredible climbing experience
                          seekers and travelers.
                        </p>
                        <a href="#">
                          Read More
                          <i className="bi bi-caret-down-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="activity-card">
                      <div className="activity-img">
                        <img
                          src="/assets/img/innerpages/location-modal-activity-img2.jpg"
                          alt=""
                        />
                      </div>
                      <div className="activity-content">
                        <h6>Sunset &amp; Night View</h6>
                        <p>
                          The Eiffel Tower at sunset and night offers one of the
                          most breathtaking views in the world.
                        </p>
                        <a href="#">
                          Read More
                          <i className="bi bi-caret-down-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="activity-card">
                      <div className="activity-img">
                        <img
                          src="/assets/img/innerpages/location-modal-activity-img3.jpg"
                          alt=""
                        />
                      </div>
                      <div className="activity-content">
                        <h6>Bike Tour</h6>
                        <p>
                          Ride through the city's charming streets, soak in the
                          beauty of iconic landmarks, and enjoy an active and
                          eco-friendly adventure.
                        </p>
                        <a href="#">
                          Read More
                          <i className="bi bi-caret-down-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="single-activity">
                <span className="title">Day-02</span>
                <div className="row g-4">
                  <div className="col-md-4 col-sm-6">
                    <div className="activity-card">
                      <div className="activity-img">
                        <img
                          src="/assets/img/innerpages/location-modal-activity-img4.jpg"
                          alt=""
                        />
                      </div>
                      <div className="activity-content">
                        <h6>Breathtaking 360° views</h6>
                        <p>
                          From sunrise to sunset to sparkling nightscapes, the
                          Eiffel Tower’s 360° views will leave you speechless.
                        </p>
                        <a href="#">
                          Read More
                          <i className="bi bi-caret-down-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="activity-card">
                      <div className="activity-img">
                        <img
                          src="/assets/img/innerpages/location-modal-activity-img5.jpg"
                          alt=""
                        />
                      </div>
                      <div className="activity-content">
                        <h6>Champagne Sunset</h6>
                        <p>
                          Imagine sipping a glass of fine champagne while
                          watching the sunset from the Eiffel Tower.
                        </p>
                        <a href="#">
                          Read More
                          <i className="bi bi-caret-down-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-accommodation"
              role="tabpanel"
              aria-labelledby="pills-accommodation-tab"
            >
              <div className="content-wrapper">
                <div className="accommodation-wrap">
                  <div className="accommodation-img">
                    <img
                      src="/assets/img/innerpages/location-modal-accommodation-img.jpg"
                      alt=""
                    />
                  </div>
                  <div className="accommodation-content">
                    <h6>
                      <a href="hotel-details.html">
                        Rajnonikanto Hotel, San Diego
                      </a>
                    </h6>
                    <div className="rating-and-location-area">
                      <div className="rating-area">
                        <ul className="rating-star">
                          <li>
                            <i className="bi bi-star-fill" />
                          </li>
                          <li>
                            <i className="bi bi-star-fill" />
                          </li>
                          <li>
                            <i className="bi bi-star-fill" />
                          </li>
                          <li>
                            <i className="bi bi-star-fill" />
                          </li>
                          <li>
                            <i className="bi bi-star-fill" />
                          </li>
                        </ul>
                        <span>3,354 reviews</span>
                      </div>
                      <a
                        href="https://www.google.com/maps"
                        className="location"
                      >
                        <svg
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M7 14C7 14 12.25 9.02475 12.25 5.25C12.25 3.85761 11.6969 2.52226 10.7123 1.53769C9.72774 0.553123 8.39239 0 7 0C5.60761 0 4.27226 0.553123 3.28769 1.53769C2.30312 2.52226 1.75 3.85761 1.75 5.25C1.75 9.02475 7 14 7 14ZM7 7.875C6.30381 7.875 5.63613 7.59844 5.14384 7.10616C4.65156 6.61387 4.375 5.94619 4.375 5.25C4.375 4.55381 4.65156 3.88613 5.14384 3.39384C5.63613 2.90156 6.30381 2.625 7 2.625C7.69619 2.625 8.36387 2.90156 8.85616 3.39384C9.34844 3.88613 9.625 4.55381 9.625 5.25C9.625 5.94619 9.34844 6.61387 8.85616 7.10616C8.36387 7.59844 7.69619 7.875 7 7.875Z" />
                        </svg>
                        San Fransico
                      </a>
                    </div>
                    <p>
                      Whether you're visiting Paris for a romantic getaway, an
                      adventure, or a luxury vacation, finding the right
                      accommodation with excellent facilities enhances your
                      experience.
                    </p>
                    <ul>
                      <li>
                        <svg
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width={14} height={14} rx={7} />
                          <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                        </svg>
                        Comfortable &amp; Stylish Rooms.
                      </li>
                      <li>
                        <svg
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width={14} height={14} rx={7} />
                          <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                        </svg>
                        Comfortable &amp; Stylish Rooms.
                      </li>
                      <li>
                        <svg
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width={14} height={14} rx={7} />
                          <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                        </svg>
                        Spa &amp; Wellness Facilities.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-transport"
              role="tabpanel"
              aria-labelledby="pills-transport-tab"
            >
              <div className="content-wrapper">
                <div className="transport-wrap">
                  <div className="title-area">
                    <h6>
                      <svg
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="M17.2591 5.37406C17.1808 5.37406 17.1003 5.38524 17.0201 5.40743L16.1117 5.65767L15.1684 3.35986C14.9013 2.70884 14.1113 2.17928 13.4076 2.17928H4.5797C3.87596 2.17928 3.08604 2.70884 2.81889 3.35986L1.87683 5.65454L0.979856 5.40743C0.902048 5.38564 0.821662 5.37442 0.740861 5.37406C0.311619 5.37406 0 5.70198 0 6.15388V6.68949C0 7.217 0.429089 7.64608 0.956592 7.64608H1.05929L0.907079 8.01694C0.658824 8.62181 0.456868 9.64567 0.456868 10.2994V14.8644C0.456868 15.3919 0.886034 15.821 1.41346 15.821H2.66285C3.19035 15.821 3.61944 15.3919 3.61944 14.8644V13.7243H14.368V14.8644C14.368 15.3919 14.7971 15.821 15.3246 15.821H16.5739C17.1014 15.821 17.5305 15.3919 17.5305 14.8644V10.2994C17.5305 9.64575 17.3286 8.62181 17.0802 8.01694L16.928 7.64608H17.0434C17.5708 7.64608 18 7.217 18 6.68949V6.15388C18 5.70198 17.6885 5.37406 17.2591 5.37406ZM2.56282 7.12646L3.98968 3.65082C4.14954 3.26145 4.6247 2.94287 5.0456 2.94287H12.9418C13.3627 2.94287 13.8379 3.26145 13.9977 3.65082L15.4245 7.12646C15.5844 7.51583 15.3708 7.83442 14.9499 7.83442H3.03752C2.61662 7.83442 2.40304 7.51583 2.56282 7.12646ZM5.74812 11.5227C5.74812 11.7331 5.57594 11.9053 5.36549 11.9053H2.65489C2.44444 11.9053 2.27225 11.7331 2.27225 11.5227V10.2218C2.27225 10.0113 2.44444 9.83913 2.65489 9.83913H5.36549C5.57594 9.83913 5.74812 10.0113 5.74812 10.2218V11.5227ZM15.6895 11.5227C15.6895 11.7331 15.5173 11.9053 15.3069 11.9053H12.5963C12.3859 11.9053 12.2137 11.7331 12.2137 11.5227V10.2218C12.2137 10.0113 12.3859 9.83913 12.5963 9.83913H15.3069C15.5173 9.83913 15.6895 10.0113 15.6895 10.2218V11.5227Z" />
                        </g>
                      </svg>
                      Public Transport in Paris :
                    </h6>
                    <span>
                      <strong>Paris Metro</strong> (Subway)
                    </span>
                  </div>
                  <h6>Facilities for Traveler-</h6>
                  <ul>
                    <li>
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width={14} height={14} rx={7} />
                        <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                      </svg>
                      Fast &amp; budget-friendly way to travel.
                    </li>
                    <li>
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width={14} height={14} rx={7} />
                        <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                      </svg>
                      16 metro lines &amp; 300+ stations covering all major
                      attractions.
                    </li>
                    <li>
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width={14} height={14} rx={7} />
                        <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                      </svg>
                      Operates from 5:30 AM to 12:30 AM daily.
                    </li>
                    <li>
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width={14} height={14} rx={7} />
                        <path d="M10.6947 5.45771L6.24644 9.90835C6.17556 9.97683 6.08572 10.0123 5.99596 10.0123C5.9494 10.0124 5.90328 10.0033 5.86027 9.98542C5.81727 9.96757 5.77822 9.94138 5.7454 9.90835L3.3038 7.46675C3.16436 7.32963 3.16436 7.10515 3.3038 6.96571L4.16652 6.10059C4.29892 5.96827 4.53524 5.96827 4.66764 6.10059L5.99596 7.42891L9.33092 4.09155C9.36377 4.05862 9.40278 4.03249 9.44573 4.01465C9.48868 3.9968 9.53473 3.98759 9.58124 3.98755C9.67572 3.98755 9.76556 4.02539 9.83172 4.09155L10.6944 4.95675C10.8341 5.09619 10.8341 5.32067 10.6947 5.45771Z" />
                      </svg>
                      Prices vary based on demand and distance.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Location Details Modal section End*/}
  {/* Rating Modal section Start*/}
  <div
    className="modal rating-modal fade"
    id="ratingModal"
    tabIndex={-1}
    aria-labelledby="ratingModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <button
          type="button"
          className="close-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            width={10}
            height={10}
            viewBox="0 0 10 10"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2.00247 0.500545C1.79016 0.505525 1.58918 0.582706 1.4362 0.735547L0.694403 1.479C0.345704 1.82743 0.389689 2.43243 0.79164 2.83493L3.00694 5.05341L0.79164 7.27092C0.389689 7.67328 0.345566 8.27842 0.694403 8.62753L1.4362 9.37044C1.7849 9.71872 2.38879 9.67543 2.7913 9.27293L5.00659 7.05473L7.22189 9.27293C7.62467 9.67543 8.22898 9.71872 8.57699 9.37044L9.31989 8.62753C9.6679 8.27856 9.62461 7.67342 9.22182 7.27092L7.00653 5.05341L9.22182 2.83493C9.62461 2.43243 9.6679 1.82743 9.31989 1.479L8.57699 0.735547C8.22898 0.386433 7.62467 0.430557 7.22189 0.833614L5.00659 3.05126L2.7913 0.833753C2.56515 0.606635 2.27482 0.493906 2.00247 0.500545Z" />
          </svg>
        </button>
        <div className="modal-body">
          <h4 className="modal-title" id="ratingModalLabel">
            Give Your Review
          </h4>
          <ul className="star-rating-list">
            <li>
              <span>Overall</span>
              <div className="rating-container" data-rating={0}>
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
              </div>
            </li>
            <li>
              <span>Transport</span>
              <div className="rating-container" data-rating={0}>
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
              </div>
            </li>
            <li>
              <span>Food</span>
              <div className="rating-container" data-rating={0}>
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
              </div>
            </li>
            <li>
              <span>Tour Guide</span>
              <div className="rating-container" data-rating={0}>
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
              </div>
            </li>
            <li>
              <span>Accomodation</span>
              <div className="rating-container" data-rating={0}>
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
                <i className="bi bi-star star-icon" />
              </div>
            </li>
          </ul>
          <form className="review-form-wrapper">
            <div className="row g-4 mb-50">
              <div className="col-lg-12">
                <div className="form-inner">
                  <label>Your Feedback</label>
                  <textarea
                    placeholder="Write a your tour feedback"
                    defaultValue={""}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-inner">
                  <label>Email Address</label>
                  <input type="email" placeholder="Email Address" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-inner">
                  <label>Your Name</label>
                  <input type="text" placeholder="Your Name" />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-inner2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                      id="contactCheck22"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="contactCheck22"
                    >
                      Save my email address &amp; name when I comment further
                      time.
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-inner">
              <button type="submit" className="primary-btn1 black-bg">
                <span>
                  Post Comment
                  <svg
                    width={10}
                    height={10}
                    viewBox="0 0 10 10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                  </svg>
                </span>
                <span>
                  Post Comment
                  <svg
                    width={10}
                    height={10}
                    viewBox="0 0 10 10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                  </svg>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* Rating Modal section End*/}
  {/* Booking Modal section Start*/}
  <div
    className="modal booking-modal fade"
    id="bookingModal"
    tabIndex={-1}
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <button
          type="button"
          className="close-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            width={10}
            height={10}
            viewBox="0 0 10 10"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2.00247 0.500545C1.79016 0.505525 1.58918 0.582706 1.4362 0.735547L0.694403 1.479C0.345704 1.82743 0.389689 2.43243 0.79164 2.83493L3.00694 5.05341L0.79164 7.27092C0.389689 7.67328 0.345566 8.27842 0.694403 8.62753L1.4362 9.37044C1.7849 9.71872 2.38879 9.67543 2.7913 9.27293L5.00659 7.05473L7.22189 9.27293C7.62467 9.67543 8.22898 9.71872 8.57699 9.37044L9.31989 8.62753C9.6679 8.27856 9.62461 7.67342 9.22182 7.27092L7.00653 5.05341L9.22182 2.83493C9.62461 2.43243 9.6679 1.82743 9.31989 1.479L8.57699 0.735547C8.22898 0.386433 7.62467 0.430557 7.22189 0.833614L5.00659 3.05126L2.7913 0.833753C2.56515 0.606635 2.27482 0.493906 2.00247 0.500545Z" />
          </svg>
        </button>
        <div className="modal-header">
          <h4>Dates &amp; Availability</h4>
          <p>
            Select your travel date &amp; time, also minium traveller for reason
            easily booking a package.
          </p>
        </div>
        <div className="modal-body">
          <form>
            <div className="row g-4 mb-50">
              <div className="col-sm-6">
                <div className="single-field date-field">
                  <svg
                    width={18}
                    height={18}
                    viewBox="0 0 18 18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="M16.125 1.28394H14.8913V2.43609C14.9509 2.57307 14.9755 2.72275 14.9629 2.87163C14.9502 3.0205 14.9007 3.16388 14.8188 3.28883C14.7368 3.41379 14.6251 3.51638 14.4936 3.58736C14.3622 3.65834 14.2151 3.69547 14.0657 3.6954C13.9163 3.69533 13.7692 3.65807 13.6378 3.58697C13.5064 3.51587 13.3948 3.41318 13.313 3.28815C13.2312 3.16312 13.1818 3.0197 13.1693 2.87081C13.1567 2.72193 13.1815 2.57227 13.2413 2.43534V1.28409H11.5136V2.43609C11.5733 2.57304 11.598 2.72272 11.5854 2.87159C11.5728 3.02047 11.5234 3.16388 11.4415 3.28887C11.3597 3.41386 11.248 3.5165 11.1165 3.58754C10.9851 3.65858 10.838 3.69577 10.6886 3.69577C10.5392 3.69577 10.3922 3.65858 10.2607 3.58754C10.1293 3.5165 10.0176 3.41386 9.93572 3.28887C9.85387 3.16388 9.80441 3.02047 9.79183 2.87159C9.77924 2.72272 9.80391 2.57304 9.86363 2.43609V1.28394H8.13638V2.43609C8.19609 2.57304 8.22076 2.72272 8.20818 2.87159C8.19559 3.02047 8.14613 3.16388 8.06428 3.28887C7.98242 3.41386 7.87073 3.5165 7.73929 3.58754C7.60784 3.65858 7.46079 3.69577 7.31138 3.69577C7.16197 3.69577 7.01491 3.65858 6.88346 3.58754C6.75202 3.5165 6.64033 3.41386 6.55848 3.28887C6.47662 3.16388 6.42716 3.02047 6.41457 2.87159C6.40199 2.72272 6.42666 2.57304 6.48638 2.43609V1.28394H4.75875V2.43519C4.81852 2.57212 4.84327 2.72178 4.83075 2.87066C4.81823 3.01955 4.76884 3.16297 4.68704 3.288C4.60524 3.41303 4.49359 3.51572 4.36219 3.58682C4.23078 3.65792 4.08373 3.69518 3.93432 3.69525C3.78491 3.69532 3.63784 3.65819 3.50636 3.58721C3.37489 3.51623 3.26315 3.41364 3.18124 3.28868C3.09932 3.16373 3.0498 3.02035 3.03715 2.87148C3.02449 2.7226 3.0491 2.57292 3.10875 2.43594V1.28394H1.875C1.37772 1.28394 0.900806 1.48148 0.549175 1.83311C0.197544 2.18474 0 2.66165 0 3.15894L0 16.0964C4.97191e-05 16.5937 0.19761 17.0706 0.54923 17.4222C0.90085 17.7738 1.37773 17.9714 1.875 17.9714H16.125C16.6223 17.9714 17.0992 17.7738 17.4508 17.4222C17.8024 17.0706 18 16.5937 18 16.0964V3.15894C18 2.66165 17.8025 2.18474 17.4508 1.83311C17.0992 1.48148 16.6223 1.28394 16.125 1.28394ZM17.25 15.9089C17.25 16.257 17.1117 16.5909 16.8656 16.837C16.6194 17.0832 16.2856 17.2214 15.9375 17.2214H2.0625C1.7144 17.2214 1.38056 17.0832 1.13442 16.837C0.888281 16.5909 0.75 16.257 0.75 15.9089V6.34644C0.75 5.99834 0.888281 5.6645 1.13442 5.41836C1.38056 5.17222 1.7144 5.03394 2.0625 5.03394H15.9375C16.2856 5.03394 16.6194 5.17222 16.8656 5.41836C17.1117 5.6645 17.25 5.99834 17.25 6.34644V15.9089Z" />
                      <path d="M14.6287 0.591064C14.6287 0.280404 14.3769 0.0285645 14.0662 0.0285645C13.7556 0.0285645 13.5037 0.280404 13.5037 0.591064V2.84106C13.5037 3.15172 13.7556 3.40356 14.0662 3.40356C14.3769 3.40356 14.6287 3.15172 14.6287 2.84106V0.591064Z" />
                      <path d="M11.2512 0.591064C11.2512 0.280404 10.9994 0.0285645 10.6887 0.0285645C10.3781 0.0285645 10.1262 0.280404 10.1262 0.591064V2.84106C10.1262 3.15172 10.3781 3.40356 10.6887 3.40356C10.9994 3.40356 11.2512 3.15172 11.2512 2.84106V0.591064Z" />
                      <path d="M7.87378 0.591064C7.87378 0.280404 7.62194 0.0285645 7.31128 0.0285645C7.00062 0.0285645 6.74878 0.280404 6.74878 0.591064V2.84106C6.74878 3.15172 7.00062 3.40356 7.31128 3.40356C7.62194 3.40356 7.87378 3.15172 7.87378 2.84106V0.591064Z" />
                      <path d="M4.49628 0.591064C4.49628 0.280404 4.24444 0.0285645 3.93378 0.0285645C3.62312 0.0285645 3.37128 0.280404 3.37128 0.591064V2.84106C3.37128 3.15172 3.62312 3.40356 3.93378 3.40356C4.24444 3.40356 4.49628 3.15172 4.49628 2.84106V0.591064Z" />
                      <path d="M5.57379 12.859C5.57379 11.841 6.19393 11.266 6.94745 10.9237C6.31772 10.5738 5.93327 9.97518 5.93327 9.23362C5.93327 7.84346 7.14253 6.93768 9.03335 6.93768C10.665 6.93768 12.0754 7.71146 12.0754 9.2562C12.0754 10.0578 11.5991 10.5852 11.0117 10.8392C11.8151 11.133 12.4262 11.8054 12.4262 12.8442C12.4262 14.553 10.7024 15.3177 8.95704 15.3177C7.14785 15.3177 5.57379 14.5132 5.57379 12.859ZM10.4611 12.8062C10.4611 12.1583 10.0752 11.6429 8.99162 11.6429C7.89793 11.6429 7.50868 12.1281 7.50868 12.7625C7.50868 13.578 8.28429 13.9316 8.9993 13.9316C9.72377 13.9316 10.4611 13.636 10.4611 12.8062ZM7.83377 9.24273C7.83377 9.7755 8.13992 10.2237 9.04127 10.2237C9.88592 10.2237 10.171 9.82871 10.171 9.25623C10.171 8.62605 9.6497 8.29207 8.99612 8.29207C8.39034 8.29203 7.83377 8.57565 7.83377 9.24273Z" />
                    </g>
                  </svg>
                  <div className="custom-select-dropdown">
                    <input
                      type="text"
                      name="tourBookingCalendar"
                      readOnly=""
                      defaultValue="Sep 12 - Sep 20"
                    />
                    <div className="selected-date" />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="single-field">
                  <svg
                    width={18}
                    height={18}
                    viewBox="0 0 18 18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.00003 1.52136C4.02939 1.52136 0 5.55075 0 10.5214C0 12.6873 0.765549 14.6746 2.04035 16.2275C2.23702 14.6528 3.80989 13.3209 6.01543 12.6901C6.82119 13.4409 7.86199 13.8964 8.99997 13.8964C10.1112 13.8964 11.1316 13.4638 11.9292 12.7445C14.1538 13.4304 15.6928 14.8401 15.7434 16.4787C17.1465 14.8914 18 12.8067 18 10.5214C18 5.55075 13.9706 1.52136 9.00003 1.52136ZM9.00003 12.8306C8.42549 12.8306 7.88412 12.6727 7.40341 12.3993C6.24498 11.7401 5.44736 10.3912 5.44736 8.83383C5.44736 6.63003 7.04103 4.83703 9.00003 4.83703C10.9592 4.83703 12.5527 6.63003 12.5527 8.83383C12.5527 10.4151 11.7301 11.7807 10.5429 12.4284C10.0751 12.6835 9.55325 12.8306 9.00003 12.8306Z" />
                  </svg>
                  <div className="custom-select-dropdown">
                    <h6>
                      <span id="adult-qty">1</span> Adults,{" "}
                      <span id="child-qty">0</span> Child
                    </h6>
                    <span>Select Travelers</span>
                  </div>
                  <div className="custom-select-wrap">
                    <div className="title-area">
                      <h6>Travelers</h6>
                      <span>You can book for a maximum of 12 people</span>
                    </div>
                    <ul className="guest-count">
                      <li className="single-item">
                        <div className="title">
                          <h6>Adult</h6>
                          <span>16 years+</span>
                        </div>
                        <div className="quantity-counter">
                          <a
                            href="#"
                            data-type="adult"
                            className="guest-quantity__minus"
                          >
                            <i className="bi bi-dash" />
                          </a>
                          <input
                            name="adult_quantity"
                            type="text"
                            className="quantity__input"
                            defaultValue={1}
                          />
                          <a
                            href="#"
                            data-type="adult"
                            className="guest-quantity__plus"
                          >
                            <i className="bi bi-plus" />
                          </a>
                        </div>
                      </li>
                      <li className="single-item">
                        <div className="title">
                          <h6>Children</h6>
                          <span>0-16 years</span>
                        </div>
                        <div className="quantity-counter">
                          <a
                            href="#"
                            data-type="child"
                            className="guest-quantity__minus"
                          >
                            <i className="bi bi-dash" />
                          </a>
                          <input
                            name="child_quantity"
                            type="text"
                            className="quantity__input"
                            defaultValue={0}
                          />
                          <a
                            href="#"
                            data-type="child"
                            className="guest-quantity__plus"
                          >
                            <i className="bi bi-plus" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="tour-booking-calendar"
              className="calendar-wrapper full-date two"
              data-dates='[{"start_date":"2025-05-15","end_date":"no_end_date","price":"40","format_price":"$40","offer_price":"30","format_offer_price":"$30","trip_days":["monday","tuesday","wednesday","thursday","friday","saturday","sunday"]},{"start_date":"2025-05-15","end_date":"no_end_date","price":"35","format_price":"$35","offer_price":"28","format_offer_price":"$28","trip_days":["monday","tuesday","wednesday","thursday","friday","saturday","sunday"]},{"start_date":"2025-05-15","end_date":"no_end_date","price":"40","format_price":"$40","offer_price":"33","format_offer_price":"$33","trip_days":["monday","tuesday","wednesday","thursday","friday","saturday","sunday"]}]'
              data-months-name='["January","February","March","April","May","June","July","August","September","October","November","December"]'
              data-start-date="hotel-details-checkin"
              data-end-date="hotel-details-checkout"
            >
              <div className="calendar-inner">
                <div className="calendar-container">
                  <div className="calendar" id="calendar-prev">
                    <div className="calendar-header">
                      <button className="prev-month">
                        {/* Left chevron icon */}
                        <svg width={16} height={16} viewBox="0 0 16 16">
                          <path
                            d="M10 2L4 8l6 6"
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                          />
                        </svg>
                      </button>
                      <h6 id="month-year-prev">August 2025</h6>
                      <button className="next-month">
                        {/* Right chevron icon */}
                        <svg width={16} height={16} viewBox="0 0 16 16">
                          <path
                            d="M6 2l6 6-6 6"
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="calendar-days">
                      <div className="day-name">Mon</div>
                      <div className="day-name">Tue</div>
                      <div className="day-name">Wed</div>
                      <div className="day-name">Thu</div>
                      <div className="day-name">Fri</div>
                      <div className="day-name">Sat</div>
                      <div className="day-name">Sun</div>
                    </div>
                    <div className="calendar-dates" id="calendar-dates-prev">
                      Previous month dates will be populated here
                    </div>
                  </div>
                </div>
                {/* Calendar Actions */}
                <div className="calendar-actions">
                  <a
                    href="#"
                    id="tour-calendar-check"
                    className="calendar-check underline"
                  >
                    Apply
                  </a>
                </div>
              </div>
            </div>
          </form>
          <div className="package-list">
            <div
              className="accordion accordion-flush"
              id="accordionFlushPackage"
            >
              <div className="accordion-item">
                <div className="accordion-header" id="flush-package-headingOne">
                  <div
                    className="accordion-button"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-package-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-package-collapseOne"
                  >
                    <div className="batch">
                      <span>Group Tour</span>
                    </div>
                    <div className="title-area">
                      <span className="check" />
                      <h6>Thailand with Phi Phi Islands.</h6>
                    </div>
                    <span>$99.00 </span>
                  </div>
                </div>
                <div
                  id="flush-package-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="flush-package-headingOne"
                  data-bs-parent="#accordionFlushPackage"
                >
                  <div className="accordion-body">
                    <div className="tour-info-and-calculate-area">
                      <p>
                        An 11-night journey covering Bangkok{" "}
                        <i className="bi bi-arrow-right" />
                        River Kwai <i className="bi bi-arrow-right" /> Chiang
                        Rai <i className="bi bi-arrow-right" /> Chiang Mai{" "}
                        <i className="bi bi-arrow-right" /> Phi Phi{" "}
                        <i className="bi bi-arrow-right" /> Phuket.
                      </p>
                      <div className="price-calculate">
                        <span className="adult">
                          $30 <i className="bi bi-x" /> 2 Adult
                        </span>
                        <span className="children">
                          $25 <i className="bi bi-x" /> 1 Children
                        </span>
                      </div>
                    </div>
                    <div className="additional-service-area">
                      <h6>Additional Services -</h6>
                      <ul className="service-list">
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Souvenir Photographs</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$49.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Louvre Museum</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$30.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="btn-area">
                      <a href="checkout.html" className="primary-btn1 two">
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                      </a>
                      <a
                        href="checkout.html"
                        className="primary-btn1 two transparent"
                      >
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <div className="accordion-header" id="flush-package-headingTwo">
                  <div
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-package-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-package-collapseTwo"
                  >
                    <div className="batch">
                      <span>Family Tour</span>
                    </div>
                    <div className="title-area">
                      <span className="check" />
                      <h6>Jordan Classic Tour.</h6>
                    </div>
                    <span>$39.00 </span>
                  </div>
                </div>
                <div
                  id="flush-package-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-package-headingTwo"
                  data-bs-parent="#accordionFlushPackage"
                >
                  <div className="accordion-body">
                    <div className="tour-info-and-calculate-area">
                      <p>
                        An 11-night journey covering Bangkok{" "}
                        <i className="bi bi-arrow-right" />
                        River Kwai <i className="bi bi-arrow-right" /> Chiang
                        Rai <i className="bi bi-arrow-right" /> Chiang Mai{" "}
                        <i className="bi bi-arrow-right" /> Phi Phi{" "}
                        <i className="bi bi-arrow-right" /> Phuket.
                      </p>
                      <div className="price-calculate">
                        <span className="adult">
                          $30 <i className="bi bi-x" /> 2 Adult
                        </span>
                        <span className="children">
                          $25 <i className="bi bi-x" /> 1 Children
                        </span>
                      </div>
                    </div>
                    <div className="additional-service-area">
                      <h6>Additional Services -</h6>
                      <ul className="service-list">
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Souvenir Photographs</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$49.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Louvre Museum</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$30.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="btn-area">
                      <a href="checkout.html" className="primary-btn1 two">
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                      </a>
                      <a
                        href="checkout.html"
                        className="primary-btn1 two transparent"
                      >
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <div
                  className="accordion-header"
                  id="flush-package-headingThree"
                >
                  <div
                    className="accordion-button collapsed"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-package-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-package-collapseThree"
                  >
                    <div className="batch">
                      <span>Private Tour</span>
                    </div>
                    <div className="title-area">
                      <span className="check" />
                      <h6>Maldives Group Island Hopping Tour.</h6>
                    </div>
                    <span>$79.00 </span>
                  </div>
                </div>
                <div
                  id="flush-package-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-package-headingThree"
                  data-bs-parent="#accordionFlushPackage"
                >
                  <div className="accordion-body">
                    <div className="tour-info-and-calculate-area">
                      <p>
                        An 11-night journey covering Bangkok{" "}
                        <i className="bi bi-arrow-right" />
                        River Kwai <i className="bi bi-arrow-right" /> Chiang
                        Rai <i className="bi bi-arrow-right" /> Chiang Mai{" "}
                        <i className="bi bi-arrow-right" /> Phi Phi{" "}
                        <i className="bi bi-arrow-right" /> Phuket.
                      </p>
                      <div className="price-calculate">
                        <span className="adult">
                          $30 <i className="bi bi-x" /> 2 Adult
                        </span>
                        <span className="children">
                          $25 <i className="bi bi-x" /> 1 Children
                        </span>
                      </div>
                    </div>
                    <div className="additional-service-area">
                      <h6>Additional Services -</h6>
                      <ul className="service-list">
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Souvenir Photographs</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$49.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="service-info-wrap">
                            <label className="containerss">
                              <input type="checkbox" />
                              <span className="checkmark" />
                            </label>
                            <div className="service-info">
                              <h6>Louvre Museum</h6>
                              <p>
                                Offer professional photo packages or digital
                                keepsakes of key moments on the tour.
                              </p>
                            </div>
                          </div>
                          <div className="pricing-and-count-area">
                            <span>$30.00</span>
                            <div className="quantity-counter">
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__minus"
                              >
                                <i className="bi bi-dash" />
                              </a>
                              <input
                                name="quantity"
                                type="text"
                                className="quantity__input"
                                defaultValue="01"
                              />
                              <a
                                href="#"
                                data-type="adult"
                                className="quantity__plus"
                              >
                                <i className="bi bi-plus" />
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="btn-area">
                      <a href="checkout.html" className="primary-btn1 two">
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                        <span>
                          Book Now
                          <svg
                            width={10}
                            height={10}
                            viewBox="0 0 10 10"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                          </svg>
                        </span>
                      </a>
                      <a
                        href="checkout.html"
                        className="primary-btn1 two transparent"
                      >
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M16.7823 8.95775C15.7387 1.49096 14.8315 0.99707 9.00454 0.99707C3.16848 0.99707 2.26028 1.48821 1.21947 8.94769C0.764911 12.2018 1.01368 14.0987 2.05175 15.2923C3.29652 16.7227 5.54095 17.0026 8.99631 17.0026C12.4581 17.0026 14.7062 16.7218 15.9509 15.2904C16.9881 14.0987 17.2369 12.2055 16.7832 8.95775H16.7823ZM14.9165 14.3905C14.0184 15.424 11.9861 15.6307 8.99723 15.6307C6.0138 15.6307 3.98522 15.4231 3.08708 14.3914C2.34625 13.5408 2.18986 11.9192 2.57856 9.13701C3.52335 2.36897 3.83339 2.36897 9.00546 2.36897C14.1675 2.36897 14.4766 2.36897 15.4241 9.14799C15.8119 11.9238 15.6555 13.5408 14.9165 14.3905Z" />
                            <path d="M11.2863 4.19824C11.1044 4.19824 10.9299 4.27051 10.8013 4.39915C10.6726 4.52779 10.6003 4.70227 10.6003 4.88419C10.6003 5.30868 10.4317 5.71579 10.1316 6.01595C9.83139 6.31611 9.42429 6.48474 8.99979 6.48474C8.5753 6.48474 8.1682 6.31611 7.86803 6.01595C7.56787 5.71579 7.39924 5.30868 7.39924 4.88419C7.39924 4.70227 7.32697 4.52779 7.19833 4.39915C7.06969 4.27051 6.89522 4.19824 6.71329 4.19824C6.53137 4.19824 6.35689 4.27051 6.22825 4.39915C6.09961 4.52779 6.02734 4.70227 6.02734 4.88419C6.02734 5.67254 6.34051 6.42859 6.89795 6.98603C7.4554 7.54347 8.21145 7.85664 8.99979 7.85664C9.78814 7.85664 10.5442 7.54347 11.1016 6.98603C11.6591 6.42859 11.9722 5.67254 11.9722 4.88419C11.9722 4.70227 11.9 4.52779 11.7713 4.39915C11.6427 4.27051 11.4682 4.19824 11.2863 4.19824Z" />
                          </svg>
                          Add to Cart
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Booking Modal section End*/}
  {/* Enquiry Modal section Start*/}
  <div
      className="modal enquiry-modal fade"
      id="enquiryModal"
      tabIndex="-1"
      aria-labelledby="enquiryModalLabel"
      aria-hidden="true"
      data-bs-backdrop={loading ? "static" : "true"}
      data-bs-keyboard={loading ? "false" : "true"}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* Close button */}
          <button
            type="button"
            className="close-btn"
            data-bs-dismiss="modal"
            aria-label="Close"
            disabled={loading}><svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.00247 0.500545C1.79016 0.505525 1.58918 0.582706 1.4362 0.735547L0.694403 1.479C0.345704 1.82743 0.389689 2.43243 0.79164 2.83493L3.00694 5.05341L0.79164 7.27092C0.389689 7.67328 0.345566 8.27842 0.694403 8.62753L1.4362 9.37044C1.7849 9.71872 2.38879 9.67543 2.7913 9.27293L5.00659 7.05473L7.22189 9.27293C7.62467 9.67543 8.22898 9.71872 8.57699 9.37044L9.31989 8.62753C9.6679 8.27856 9.62461 7.67342 9.22182 7.27092L7.00653 5.05341L9.22182 2.83493C9.62461 2.43243 9.6679 1.82743 9.31989 1.479L8.57699 0.735547C8.22898 0.386433 7.62467 0.430557 7.22189 0.833614L5.00659 3.05126L2.7913 0.833753C2.56515 0.606635 2.27482 0.493906 2.00247 0.500545Z"></path>
                    </svg></button> 

          <div className="modal-body">
            <h4 className="modal-title" id="enquiryModalLabel">
              We’d Love to Hear From You!
            </h4>

            <form className="enquiry-form-wrapper" onSubmit={handleSubmit}>
              <div className="row g-4 mb-50">
                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="full_name"
                      placeholder="Your Name"
                      value={formData.full_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email_address"
                      placeholder="Email Address"
                      value={formData.email_address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Number of People*</label>
                    <input
                      type="text"
                      name="total_persons"
                      placeholder="Number of people"
                      value={formData.total_persons}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-inner">
                    <label>Travel Date</label>
                    <input
                      type="date"
                      name="travel_date"
                      value={formData.travel_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-inner">
                    <label>Tour Details</label>
                    <textarea
                      name="tour_detail"
                      placeholder="Write about tour info"
                      value={formData.tour_detail}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="form-inner">
                <button
                  type="submit"
                  className="primary-btn1 black-bg"
                  disabled={loading} // prevent multiple clicks
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>

              {successMsg && (
                <p className="text-success mt-2">{successMsg}</p>
              )}
              {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  {/* Enquiry Modal section End*/}

 {/* Package Details Page Start*/}
<div className="package-details-page pt-100">
        <div className="container">
          <div className="row g-lg-4 gy-5 justify-content-between">
            {/* Left side */}
            <div className="col-xl-8 col-lg-8">
              <div className="package-details-warpper">
                <div className="package-info-wrap mb-60">
                  <h4 dangerouslySetInnerHTML={{ __html: details.title }}></h4>
                  <p dangerouslySetInnerHTML={{ __html: details.description }} />

                </div>

                 {highlights?.length > 0 && (
                  <div className="highlights-tour-area mb-60">
              <h4>Highlights of the Tour</h4>
                  <div className="highlights-wrap">
               <ul className="items-list">
                 {highlights.map((item, index) => (
                  <li key={index}>
                 <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15V16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16V15C11.866 15 15 11.866 15 8Z"></path>
                                            <path d="M11.6947 6.45795L7.24644 10.9086C7.17556 10.9771 7.08572 11.0126 6.99596 11.0126C6.9494 11.0127 6.90328 11.0035 6.86027 10.9857C6.81727 10.9678 6.77822 10.9416 6.7454 10.9086L4.3038 8.46699C4.16436 8.32987 4.16436 8.10539 4.3038 7.96595L5.16652 7.10083C5.29892 6.96851 5.53524 6.96851 5.66764 7.10083L6.99596 8.42915L10.3309 5.09179C10.3638 5.05887 10.4028 5.03274 10.4457 5.01489C10.4887 4.99705 10.5347 4.98784 10.5812 4.98779C10.6757 4.98779 10.7656 5.02563 10.8317 5.09179L11.6944 5.95699C11.8341 6.09643 11.8341 6.32091 11.6947 6.45795Z"></path>
                                        </svg> {item}
                  </li>
                ))}
            </ul>

              </div>
            </div>
           )}
            <div className="feature-list-area mb-60">
              <h4>Package Features List</h4>
               <div className="row gy-md-5 gy-4 justify-content-between highlights-wraps vd">
                <div className="col-lg-6 col-md-6">
                  <div className="single-feature-list">
                    <h6>Include Features</h6>
                  <ul className="items-list">
                      {inclusions.map((item, index) => (
                        <li key={index}>
                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15V16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16V15C11.866 15 15 11.866 15 8Z"></path>
                                            <path d="M11.6947 6.45795L7.24644 10.9086C7.17556 10.9771 7.08572 11.0126 6.99596 11.0126C6.9494 11.0127 6.90328 11.0035 6.86027 10.9857C6.81727 10.9678 6.77822 10.9416 6.7454 10.9086L4.3038 8.46699C4.16436 8.32987 4.16436 8.10539 4.3038 7.96595L5.16652 7.10083C5.29892 6.96851 5.53524 6.96851 5.66764 7.10083L6.99596 8.42915L10.3309 5.09179C10.3638 5.05887 10.4028 5.03274 10.4457 5.01489C10.4887 4.99705 10.5347 4.98784 10.5812 4.98779C10.6757 4.98779 10.7656 5.02563 10.8317 5.09179L11.6944 5.95699C11.8341 6.09643 11.8341 6.32091 11.6947 6.45795Z"></path>
                                        </svg>  {item}
                        </li>
                      ))}
                    </ul>

                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="single-feature-list">
                    <h6>Exclude Features</h6>
                  <ul className="items-list exclusion">
  {exclusions.map((item, index) => (
    <li key={index}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#000000"
      >
        <circle opacity="0.5" cx="12" cy="12" r="10" strokeWidth="1.5" />
        <path
          d="M14.5 9.5L9.5 14.5M9.5 9.5L14.5 14.5"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
      {item}
    </li>
  ))}
</ul>

                  </div>
                </div>
              </div>
            </div>

     {destination?.length > 0 && (
             <div className="location-slider-wrap mb-60">
                          <h4>Relevant Activity </h4>
                          <div className="location-slider-area">
                            <div className="swiper package-dt-location-slider">
                              <Swiper className="swiper-wrapper"
                              modules={[Pagination]}
                              pagination={{ clickable: true }}
                              slidesPerView={3}
                              spaceBetween={10}
                               autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 3, // Desktop
          },
        }}
                            >
                       {destination.map((item) => (
                <SwiperSlide key={item.id} className="swiper-slide">
                  <div className="location-card">
                    <div className="destination-img">
                      <Link to={`/activity/${item.slug}`} className="location-img">
                        <img
                          src={
                            item.image
                              ? `https://planjourneysglobal.com/admin/${item.image}`
                              : "/assets/img/no-image.png"
                          }
                          alt={item.title}
                          onError={(e) => {
                            e.target.src = "/assets/img/no-image.png";
                          }}
                        />
                      </Link>
                    </div>
            
                    <div className="location-content">
                      <h6>
                        <Link to={`/activity/${item.slug}`}>
                          {item.title}
                        </Link>
                      </h6>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            
            
                               
                            </Swiper>
                            </div>
                           
                          </div>
                        </div>
                      )}


              </div>
            </div>

            {/* Right Sidebar */}
            <div className="col-lg-4">
              <div className="package-details-sidebar">
                <div className="pricing-and-booking-area mb-40">
                  {details.discount_percent && (
                    <div className="batch">
                      <span>{details.discount_percent}% Off</span>
                    </div>
                  )}
<h6 >Starting From</h6>
                  <div className="price-area">
                    
                    <span>
                   
                        <span>{getPrice(details)}</span>
                      <sub> / Person</sub>
                    </span>
                  </div>

                  <ul>
                
                    <li> Your Safety is Our Top Priority.</li>
                  </ul>

               

                  <button
                    className="primary-btn1 transparent"
                    data-bs-toggle="modal"
                    data-bs-target="#enquiryModals"
                  >
                  <span>
                                   Book Now
                                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z">
                                        </path>
                                    </svg>
                                </span>
                                <span>
                                    Book Now
                                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z">
                                        </path>
                                    </svg>
                                </span>
                  </button>

                  <span>Bonus Activity Included – Limited Time!</span>
                  <button className="whatsapp" type="button" onClick={shareOnWhatsApp}>
  <svg class="my-float animate__animated animate__pulse animate__infinite" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
</svg> whatsapp
</button>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

  {/* Package Details Page End*/}






  <BookingModal
        // Pass the API data as props. 
        // Ensure the field names match your API response (e.g., details.package_name)
        packageName={"active " + (details.package_name || "")}
        packageId={details.id || ""} 
        defaultDestination={details.destination || ""}
        type="package" 
      />
  <Footer />
</>

    )}
export default ActivityDetails;